import React, { Component } from 'react';
import { connect } from 'react-redux';
import ProgressBar from '../../components/progressbar';
import '../../components/balancestyle.scss';

class TransactionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: 'deposit',
    };
  }

  render() {
    const { tab } = this.state;
    const { transactions, humHandle, handle, confirmations, reqConfirmations, override } = this.props;

    let depositTrans;

    if (transactions && transactions.length) {
      depositTrans = transactions.filter(function (item) {
        return item.type === 'RECEIVE';
      });
    }

    const transactionLoop = depositTrans && depositTrans.map((value, index) => {
      return (
        <div className="confirmations confirmations-modal" key={index}>
          <div>
            <p>
              Amount:
              <span> {value.quantity ? value.quantity : null}</span>
            </p>
          </div>
          <div>
            <ProgressBar max={reqConfirmations + 1} current={confirmations} override={override} />
          </div>
          <div>
            <p>
              Min. Req. Confirmations:
              <span> {confirmations} / {reqConfirmations}</span>
            </p>
            <p>
              Status:
              <span style={{ textTransform: 'capitalize' }}>
                {value.status.toLowerCase()}
              </span>
            </p>
            { value.txId ? (
              <p>
                Txid:
                <a href={'https://live.blockcypher.com/' + handle.toLowerCase() + '/tx/' + value.txId} target="_blank" rel="noopener noreferrer"> {value.txId}</a>
              </p>
            ) : (
              null
            )}
          </div>
        </div>
      );
    });

    return (
      <div className="grid-x modal-main">
        <div className="modal-title" style={{ marginBottom: 12 }}>
          <div className={'card-coin ' + humHandle.replace(/\s/g, "-").toLowerCase()}>
            <img alt={humHandle} src={process.env.REACT_APP_CDN + '/assets/icons/assets/' + humHandle.replace(/\s/g, "-").toLowerCase() + '.svg'} />
          </div>
          <div className="modal-heading">Transactions</div>
        </div>
        <div className="trans-tabs">
          <div className={tab === 'deposit' ? 'active' : ''}>
            Deposit
            <div />
          </div>
          {/* <div className={tab === 'deposit' ? 'active' : ''} onClick={() => this.setState({ tab: 'deposit' })}>
            Deposit
            <div />
          </div> */}
          {/* <div className={tab === 'withdraw' ? 'active' : ''} onClick={() => this.setState({ tab: 'withdraw' })}>
            Withdraw
            <div />
          </div> */}
        </div>
        <div className="cell small-12 medium-12 large-12">
          {(depositTrans && depositTrans.length > 0) ? (
            transactionLoop
          ) : (
            <p>No transactions found.</p>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps)(TransactionModal);
